export default __webpack_public_path__ + "static/eng-1-c84949803dcd159e589e3f1f62537c96.jpg";